import { instance } from '@/services/iss-nattag-api.service'
import { Profile } from '@/types/profile'
import { AxiosResponse } from 'axios'

const URL = 'profile'

export const getProfile = (): Promise<AxiosResponse<Profile>> =>
  instance.get(`${URL}`)
